export const GET_QUALIFIER_CONFIG = 'GET_QUALIFIER_CONFIG'
export const ADD_LOG = 'ADD_LOG'
export const CLEAR_LOG = 'CLEAR_LOG'
export const GET_CONFIG_INTERVAL = 'GET_CONFIG_INTERVAL'
export const CLEAR_INTERVAL = 'CLEAR_INTERVAL'
